import { Dispersion } from 'src/app/shared/models/dispersions';
import { MomentService } from './../../../shared/services/moment.service';
import { Component, OnInit } from '@angular/core';
import { DispersionsService } from 'src/app/shared/services/dispersions.service';

@Component({
  selector: 'app-dispersion-partial',
  templateUrl: './dispersion-partial.component.html',
  styleUrls: ['./dispersion-partial.component.scss']
})
export class DispersionPartialComponent implements OnInit {
  public dispersionsPending: any[] = [];
  public dispersion: any;
  public dispersionExecute: Dispersion;
  public popups: any[] = [];
  constructor(
    private  dispersionService: DispersionsService,
    private moment: MomentService
  ) {
    this.dispersionExecute = new Dispersion();
    this.popups['dispersar'] = { name: 'runDispersion', visible: false }
  }

  ngOnInit() {
    console.log('ngOnInit !!');
    this.getDipsersionsPartials();
  }

  getDipsersionsPartials() {
    this.dispersionService.getDispersionsPartials().toPromise()
    .then((result: any) => {
      console.log(result);
      this.dispersionsPending = result.data;
    })
    .catch(err => {
      console.log(err);
    });
  }
  selectDispersion(_dispersion) {
    this.dispersion = _dispersion;
  }
  executeDispersion(id) {
    console.log(id);
    this.dispersionExecute.dispersionAmount = this.dispersionExecute.granTotal;
    this.dispersionExecute.isDispersionPartial = true;
    this.dispersionExecute.dispersionPartialId = this.dispersion.id;
    this.dispersionExecute.status = 1;
    this.dispersionExecute.dateCreated = parseInt(this.moment.format(new Date(),'YYYYMMDD'));
    this.dispersionExecute.dateScheduled = parseInt(this.moment.format(new Date(),'YYYYMMDD'));
    this.dispersionExecute.dateExecuted = null;
    this.dispersionExecute.beneficiaries = [];
    this.dispersionExecute.beneficiaries.push(this.dispersion.beneficiarie);
    this.dispersionExecute.beneficiaries[0].amount = this.dispersionExecute.granTotal;
    this.dispersionExecute.tax = 0;
    this.dispersionExecute.fees = 0;
    console.log(this.dispersionExecute);
  }
  get maxAmountDispersion() {
    return this.dispersion ? (this.dispersion.amountPending > 80000 ? 80000 : this.dispersion.amountPending) : 0;
  }
  isPopupVisible(_name) {
    return this.popups[_name].visible;
  }
  openPopup(_name) { 
    console.log('Popup Open: ',_name);
    this.popups[_name].visible = true;
    switch(_name) {
      case 'dispersar': 
            this.dispersionExecute = new Dispersion(this.dispersion.dispersionOrigin);
            this.dispersionExecute.granTotal = 0;
            break;
      default: break;
    }
  }
  closePopup(_name) {
    console.log('Popup Close: ',_name);
    this.popups[_name].visible = false 
  }
}
